<template>
  <div
    v-if="promotionBanner"
    class="promotion-banner"
  >
    {{ promotionBanner }}
  </div>
  <div class="card-element" :class="{'with-banner' : promotionBanner}">
      <div
        v-if="fiberCheckHeader"
        class="card-row header"
      >
        <h4>{{ fiberCheckHeader }}</h4>
      </div>
      <div
        v-if="location && addressDisplay"
        class="card-row header address"
      >
        <PostalResults
          :address-display="addressDisplay"
          @change-address="location = null"
        />
      </div>
      <div v-auto-animate>
        <postal-box
          v-if="!location"
          v-model:loading="loading"
          @location="location = $event"
        />
        <div
          v-show="loading"
          key="check"
          class="card-row loading"
        >
          <div class="status-header loading">
            <icon
              icon="loader"
              size="sm"
            />
            <span>Glasvezel beschikbaarheid controleren</span>
          </div>
        </div>

        <!-- Glasvezel resultaten  -->
        <fiber-check-results
          v-if="!loading && fiberStatus"
          :status="fiberStatus"
          :provider="fiberProvider"
          :plannedDate="fiberPlannedDate"
          :location="location"
          :url="url"
          :fiberCheckCaption="fiberCheckCaption"
        />
      </div>
  </div>
</template>
<script setup>
import Icon from 'vue-elements/icon/Icon.vue';
import { ref, computed } from 'vue';
import PostalBox from './components/postalBox.vue';
import PostalResults from './components/postalResults.vue';
import FiberCheckResults from './components/fiberCheckResults.vue';

const props = defineProps({
    prefillOptions: {
        type: String,
        default: '',
    },
    productTypePrefill: {
        type: String,
        default: '',
    },
    providerPrefillOptions: {
        type: String,
        default: '',
    },
    promotionBanner: {
        type: String,
        default: '',
    },
    fiberCheckHeader: {
        type: String,
        default: '',
    },
    fiberCheckCaption: {
        type: String,
        default: '',
    },
});

const comparerUri = ref('/internet/vergelijken');

const loading = ref(false);
const location = ref(null);

const fiberStatus = computed(() => {
    if (location.value === null || location.value.fiber_summary === null) {
        return '';
    }
    return location.value.fiber_summary;
});

const fiberProvider = computed(() => {
  return location.value?.fiber_network || '';
});

const fiberPlannedDate = computed(() => {
  return location.value?.fiber_plan_date || '';
});


const addressDisplay = computed(() => (location.value ? `${location.value.street} ${location.value.number}${location.value.numberExtension ? location.value.numberExtension : ''}, ${location.value.postCode} ${location.value.city}` : ''));

// const parsedProductTypePrefill = computed(() => (productTypePrefill.value ? `productType=${productTypePrefill.value}` : ''));
const parsedPrefillOptions = computed(() => {
    if (props.prefillOptions === '') {
        return '';
    }
    return new URLSearchParams(JSON.parse(props.prefillOptions)).toString();
});
const parsedProviderPrefillOptions = computed(() => {
    if (props.providerPrefillOptions === '') {
        return '';
    }
    return `providers=${JSON.parse(props.providerPrefillOptions)
        .toString()}`;
});

const parsedProductTypePrefill = computed(() => (props.productTypePrefill ? `productType=${props.productTypePrefill}` : ''));

const dynamicUri = computed(() => {
    if (location.value === null) {
        return '';
    }
    let uri = `?${new URLSearchParams({
        postcode: location?.value.postCode,
        nr: `${location.value.number}${location.value.numberExtension ? `-${location.value.numberExtension}` : ''}`.trim(),
    })}`;

    uri += parsedPrefillOptions.value ? `&${parsedPrefillOptions.value}` : '';
    uri += parsedProviderPrefillOptions.value ? `&${parsedProviderPrefillOptions.value}` : '';
    uri += parsedProductTypePrefill.value ? `&${parsedProductTypePrefill.value}` : '';

    return uri;
});

const url = computed(() => `${comparerUri.value}${dynamicUri.value}`);

</script>
